/* prodig-rental-cart (= 見積もりカートの正本ライブラリ。 2026-08-14 新設)
   localStorage に保存する「まとめて見積もりカート」の読み書き・価格計算・
   ヘッダーバッジ描画をここ 1 か所に集約する。 読み込み元は 3 か所:
     - sections/prodig-rental-header.liquid  (= 全ページのバッジ)
     - snippets/prodig-rental-estimate.liquid (= 商品ページの「カートに入れる」)
     - sections/prodig-rental-page-contact.liquid (= /pages/contact のカート一覧・送信)
   多重読み込みしても先勝ちガードで 1 回しか初期化されない。

   【カート行の構造 (確定仕様 2026-08-14)】
     { handle : metaobject handle (文字列)
       name   : 機種名 (metaobject.name)
       maker  : メーカー名 (metaobject.maker)
       start  : 貸出開始日 ISO "YYYY-MM-DD"
       end    : 返却日 ISO "YYYY-MM-DD"
       qty    : 台数 (整数 >= 1)
       cp     : 価格チェックポイント [[7,総額],[14,総額],[30,総額],[90,総額],[180,総額],[365,総額]] }
   cp はカート追加時点の価格を行ごとに固定保存する (= /pages/contact からは任意商品の
   metaobject 価格を引けないため。 追加後に商品側の価格が変わっても行の cp は変わらない)。

   【日数の数え方 (確定仕様)】
   開始日・返却日の両端含み (= 8/21〜8/27 は 7日)。 lineDays() 参照。

   【価格 (グライド方式)】
   perUnit(days, cp) はチェックポイント間の線形補間 + 100円単位切り上げ。
   商品ページウィジェット assets/prodig-rental-estimate.js もこの関数を使う
   (= 価格ロジックの正本はここ。 重複実装しない)。

   【同一ページ内の更新通知】
   保存のたびに document へ CustomEvent 'prodig-rental-cart:change' を投げる。
   他タブは 'storage'、 bfcache 復帰は 'pageshow' で拾う (バッジは全部購読済み)。 */
(function () {
  'use strict';
  if (window.ProdigRentalCart) return; // 多重読み込みガード (先勝ち)
  var KEY = 'prodig_rental_cart';
  var EVENT = 'prodig-rental-cart:change';
  var DAY = 86400000;
  var ISO_RE = /^\d{4}-\d{2}-\d{2}$/;

  function ceilTo(n, unit) { return Math.ceil(n / unit) * unit; }

  // 1台あたりの期間料金。 cp = [[日数, その日数までの1台総額], ...] 昇順。
  // days < 最初の区切り(7日) は固定額、 days > 最後の区切り(365日) は別途見積もり(null)。
  // 区切りの間は線形補間 (= グライド方式) して 100円単位で切り上げる。
  function perUnit(days, cp) {
    if (!days || days <= 0 || !cp || cp.length < 2) return null;
    if (days < cp[0][0]) return ceilTo(cp[0][1], 100);
    if (days > cp[cp.length - 1][0]) return null;
    for (var i = 0; i < cp.length - 1; i++) {
      var d0 = cp[i][0], v0 = cp[i][1], d1 = cp[i + 1][0], v1 = cp[i + 1][1];
      if (days <= d1) return ceilTo(v0 + (v1 - v0) * (days - d0) / (d1 - d0), 100);
    }
    return ceilTo(cp[cp.length - 1][1], 100);
  }

  function parseISO(s) {
    var p = String(s).split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function pad2(x) { return (x < 10 ? '0' : '') + x; }
  function toISO(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }

  // 利用日数 = 開始日・返却日の両端含み (8/21〜8/27 = 7日)。
  // 根拠 = PRODIGレンタル規約 第2条2項・3項 (2026-09-01 施行)。
  // 到着日を第1日として起算し、返還のため運送業者に引き渡した日で終了 = 両端が利用期間。
  // ウィジェット側 (prodig-rental-estimate.js rentalDays) も同一の数え方 (2026-08-15 統一)。
  function lineDays(line) {
    return Math.round((parseISO(line.end) - parseISO(line.start)) / DAY) + 1;
  }

  function isValidLine(l) {
    return !!l && typeof l === 'object' &&
      typeof l.handle === 'string' && l.handle !== '' &&
      typeof l.name === 'string' &&
      ISO_RE.test(l.start) && ISO_RE.test(l.end) &&
      typeof l.qty === 'number' && isFinite(l.qty) && l.qty >= 1 &&
      Array.isArray(l.cp) && l.cp.length >= 2;
  }

  // JSON 破損・型崩れは黙って握りつぶさず空カート扱いにフォールバックする
  // (= 買い物を止めない。 不正な行だけ落とし、全滅なら空)。
  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      var ok = [];
      for (var i = 0; i < list.length; i++) if (isValidLine(list[i])) ok.push(list[i]);
      return ok;
    } catch (e) { return []; }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode 等 */ }
    document.dispatchEvent(new CustomEvent(EVENT));
  }

  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
    document.dispatchEvent(new CustomEvent(EVENT));
  }

  // 同じ機種・同じ開始日・同じ返却日の行が既にあれば台数を合算、それ以外は別行 (確定仕様)。
  // 保存後のカート配列を返す。
  // 直前1回分の追加操作を lastAdd に控える (= undoLastAdd() 用。多段undoはしない。
  // 2026-08-15 追加・倉智さん指示: 誤追加・連打の取り消し手段)。
  var lastAdd = null;

  function add(line) {
    var list = load();
    var merged = false;
    for (var i = 0; i < list.length; i++) {
      var l = list[i];
      if (l.handle === line.handle && l.start === line.start && l.end === line.end) {
        l.qty += line.qty;
        l.cp = line.cp; // 最新の追加時点の価格で更新 (同一行なら新しい方が実勢)
        merged = true;
        break;
      }
    }
    if (!merged) list.push(line);
    lastAdd = { handle: line.handle, start: line.start, end: line.end, qty: line.qty, wasNew: !merged };
    save(list);
    return list;
  }

  // 直前の追加操作だけを打ち消す。 新規行だった場合は行ごと削除、既存行への合算だった
  // 場合は合算前の台数に戻す。 1回打ち消したら控えは消す (= 二重取り消し不可)。
  // 取り消すものが無ければ null、あれば保存後のカート配列を返す。
  function undoLastAdd() {
    if (!lastAdd) return null;
    var op = lastAdd;
    lastAdd = null;
    var list = load();
    for (var i = 0; i < list.length; i++) {
      var l = list[i];
      if (l.handle === op.handle && l.start === op.start && l.end === op.end) {
        if (op.wasNew || l.qty - op.qty < 1) list.splice(i, 1);
        else l.qty -= op.qty;
        break;
      }
    }
    save(list);
    return list;
  }

  function totalQty(list) {
    var s = 0;
    for (var i = 0; i < list.length; i++) s += list[i].qty;
    return s;
  }

  /* ---- カート追加トースト (2026-08-14 追加・倉智さん指示) ----
     「カートに入れる」押下時に画面下部 (SP) / 右下 (PC) へ浮かぶ通知。
     旧・ウィジェット内インライン表示 (data-re="added") は気づきにくいため置き換えた。
     - 連打時は前のトーストを DOM ごと置き換えて台数を更新する (積み重ねない)
     - 約4秒で自動で消える。リンクにホバー/フォーカス中は 1 秒刻みで延命する
     - role="status" + aria-live="polite"。アニメーション抑制は CSS 側の
       prefers-reduced-motion (assets/prodig-rental-estimate.css の .prc-toast) が担当
     - 見た目の CSS は prodig-rental-estimate.css にある (= 現状トーストを出すのは
       商品ページウィジェットだけなので、そこで必ず読み込まれる)。他ページから
       showToast を呼ぶ場合は同 CSS の読み込みが必要。 */
  var TOAST_ID = 'prodig-rental-cart-toast';
  var toastTimer = null;
  var raf = (typeof window.requestAnimationFrame === 'function')
    ? window.requestAnimationFrame.bind(window)
    : function (cb) { setTimeout(cb, 16); };

  function showToast(message, opts) {
    var old = document.getElementById(TOAST_ID);
    if (old && old.parentNode) old.parentNode.removeChild(old); // 連打は置き換え
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }

    var t = document.createElement('div');
    t.id = TOAST_ID;
    t.className = 'prc-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    var msg = document.createElement('span');
    msg.className = 'prc-toast__msg';
    msg.textContent = message;
    t.appendChild(msg);
    // 「取り消す」等のアクションボタン (2026-08-15 追加。 押した側でトーストを出し直す想定)
    if (opts && typeof opts.onUndo === 'function') {
      var u = document.createElement('button');
      u.type = 'button';
      u.className = 'prc-toast__undo';
      u.textContent = opts.undoText || '取り消す';
      u.addEventListener('click', opts.onUndo);
      t.appendChild(u);
    }
    if (opts && opts.linkHref) {
      var a = document.createElement('a');
      a.className = 'prc-toast__link';
      a.href = opts.linkHref;
      a.textContent = opts.linkText || 'カートを見る →';
      t.appendChild(a);
    }
    document.body.appendChild(t);

    // 2フレーム後に .is-show を付けて transition でスライドイン
    raf(function () { raf(function () { t.classList.add('is-show'); }); });

    var hovering = false;
    t.addEventListener('mouseenter', function () { hovering = true; });
    t.addEventListener('mouseleave', function () { hovering = false; });

    function scheduleHide(delay) {
      toastTimer = setTimeout(function () {
        // ホバー中・トースト内リンクにフォーカス中は消さず、1秒後に再判定する
        if (hovering || t.contains(document.activeElement)) { scheduleHide(1000); return; }
        t.classList.remove('is-show');
        toastTimer = setTimeout(function () {
          if (t.parentNode) t.parentNode.removeChild(t);
        }, 300); // CSS transition (0.25s) の完了を待ってから DOM を掃除
      }, delay);
    }
    scheduleHide(4000);
    return t;
  }

  /* ---- ヘッダーバッジ ----
     [data-prodig-cart-badge] 要素の中の [data-prodig-cart-count] に合計台数を出す。
     カートが空ならバッジ (数字) を隠す (アイコン自体は出したまま)。 */
  function renderBadges() {
    var badges = document.querySelectorAll('[data-prodig-cart-badge]');
    if (!badges.length) return;
    var qty = totalQty(load());
    for (var i = 0; i < badges.length; i++) {
      var num = badges[i].querySelector('[data-prodig-cart-count]');
      if (!num) continue;
      num.textContent = qty;
      num.hidden = qty < 1;
    }
  }

  document.addEventListener('DOMContentLoaded', renderBadges);
  document.addEventListener(EVENT, renderBadges);
  window.addEventListener('pageshow', renderBadges);           // 戻る (bfcache) 対応
  window.addEventListener('storage', function (e) {            // 他タブでの追加/削除
    if (e.key === KEY || e.key === null) renderBadges();
  });

  window.ProdigRentalCart = {
    KEY: KEY,
    EVENT: EVENT,
    load: load,
    save: save,
    clear: clear,
    add: add,
    undoLastAdd: undoLastAdd,
    totalQty: totalQty,
    perUnit: perUnit,
    ceilTo: ceilTo,
    showToast: showToast,
    lineDays: lineDays,
    parseISO: parseISO,
    toISO: toISO,
    renderBadges: renderBadges
  };
})();
